import React from 'react';
import PropTypes from 'prop-types';
import SMFormSelectBox from 'components/dashboard/form/SMFormSelectBox';
import SMFormCheckBox from 'components/dashboard/form/SMFormCheckBox';
import SMReservationHelper from 'components/helpers/SMReservationHelper';
import SMFormatHelper from 'components/helpers/SMFormatHelper';

class SMReservationEditViewOptions extends React.Component {


  checkBoxDidChangeValue(e) {
    this.props.delegate.changeOptions(this.props.name, e.currentTarget.name, e.currentTarget.value, e.currentTarget.checked);
  }

  selectBoxDidChangeValue(e) {
    this.props.delegate.changeOptionsNumber(this.props.name, e.currentTarget.name, e.currentTarget.value, e.currentTarget.checked);
  }

  render() {
    const reservation = this.props.reservation;
    const roomOptions = this.props.room_options;
    const name = this.props.name;
    const reservedOptions = this.props.reserved_options;
    const errors = this.props.errors;

    let items = [];

    // 仕様:
    //   オプション情報は現在の設定を反映
    //   予約時の情報を保持すると他項目の編集方針とブレる
    if (roomOptions != null) {
      for (var i = 0; i < roomOptions.length; i++) {
        let key = name + "-" + roomOptions[i].id;
        let itemNumberElements = [];
        let selectBoxItems = [];
        let checked = false;
        let number = 1;

        if (reservedOptions) {
          for (let j = 0; j < reservedOptions.length; j++) {
            if (roomOptions[i].id == reservedOptions[j][name + '_id']) {
              checked = true;
              number = reservedOptions[j].number;
              break;
            }
          }
        }

        if (roomOptions[i].countable) {
          for (var j = 0; j < roomOptions[i].max_count; j++) {
            selectBoxItems.push({value: j + 1, label: j + 1});
          }
          itemNumberElements = [
            '数量',
            <span className="form-select__inner ml5">
              <label className="form-select">
                <SMFormSelectBox
                  name={roomOptions[i].id}
                  items={selectBoxItems}
                  selectedValue={number}
                  delegate={this}
                  options={{
                    className: 'w60',
                    disabled: (!SMReservationHelper.isDetailEditable(reservation) || !checked)
                  }} />
              </label>
            </span>,
          ];
        } else if (checked) {
          itemNumberElements =
            <input
              type="hidden"
              name={"reserved_" + name + 's[][number]'}
              value='1' />;
        }

        items.push([
          <SMFormCheckBox
            value={roomOptions[i].id}
            key={key}
            id={key}
            name={"reserved_" + name + "s[][" + name + "_id]"}
            checked={checked}
            delegate={this}
            options={{disabled: !SMReservationHelper.isDetailEditable(reservation)}} />,

          <label htmlFor={key} className="form-checkbox w200">
            {roomOptions[i].name}
          </label>,

          <span className="dib w150">
            {roomOptions[i].price_text} / {roomOptions[i].price_unit_text}
          </span>,
          itemNumberElements,
          <p className={"dashboard-title__supplement mt10 " + (roomOptions.length > 0 ? "mb20" : '')}>
            {roomOptions[i].description}
          </p>
        ]);
      }
    }

    let errorMessage;
    if (errors && errors.length > 0 && name === 'option_food') {
      errorMessage = <span className="message-important">
          {SMFormatHelper.errorText('Reservation', 'reserved_option_foods', errors)}
      </span>;
    }

    return (
      <td>
        {items}
        {errorMessage}
      </td>
    );
  }
}

SMReservationEditViewOptions.propTypes = {
  name: PropTypes.string.isRequired,
  room_options: PropTypes.array.isRequired,
  reserved_options: PropTypes.array.isRequired,
  reservation: PropTypes.object.isRequired,
  delegate: PropTypes.object
};
export default SMReservationEditViewOptions;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMReservationEditViewOptions.jsx